<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    let that = this
    const pageAccessedByReload =
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType('navigation')
        .map(nav => nav.type)
        .includes('reload')
    if (pageAccessedByReload) {
      setTimeout(() => {
        that.beforeunloadHandler()
      }, 1000)
    }
  },
  methods: {
    beforeunloadHandler (e) {
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue